import React from 'react';
import PropTypes from 'prop-types';
import Popup from '../../common/Popup';


const UpdateRedact = ({ showRedactPopup, closeRedactPopup, redact }) => (
  <Popup show={showRedactPopup}
           clsName="dockets-popup"
           topBarTitle="Update or Redact Entry?"
           onClose={closeRedactPopup} >
    <div className="inner-text">
      <p>
          Updating / Redacting will delete existing data and fetch the new data from Pacer.
          If the court has removed a PDF, this will remove it from CourtDrive. If the court corrected an error,
          this will make the same correction.
      </p>
      <p>
          You should only update / redact an existing entry if you believe it requires correction (e.g., a
          court ordered redaction, docketing error, updated pleading).
      </p>
    </div>

    <div className="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
      <div className="ui-dialog-buttonset">
        <button type="button" onClick={closeRedactPopup}>Cancel</button>
        <button type="button" onClick={redact}>Continue</button>
      </div>
    </div>
  </Popup>
);

UpdateRedact.defaultProps = {
  showRedactPopup: false,
};

UpdateRedact.propTypes = {
  closeRedactPopup: PropTypes.func.isRequired,
  redact: PropTypes.func.isRequired,
  showRedactPopup: PropTypes.bool,
};

export default UpdateRedact;



/** WEBPACK FOOTER **
 ** ./src/components/case/docket/UpdateRedact.jsx
 **/